import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearCache,
    getCacheList } from '../../../../redux/thunks/adminSettingsThunk';
import { Box,
    Checkbox,
    Grid,
    Paper,
    Popover,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Tabs } from '@mui/material';
import { CustomAccordion, CustomButton, CustomButtonGroup } from '../../../shared';
import { capitalizeFirstLetter } from '../../../../utility';
import { makeStyles } from '@mui/styles';
import { toast } from 'react-toastify';
import { ActionsIcon, DownloadCloudIcon, Trash } from '../../../../assets';
import { Cached } from '@mui/icons-material';

const useStyles = makeStyles({
    tabs: {
        '& .MuiTabs-indicator': {
            backgroundColor: '#733567',
            height: 2
        },
        '& .MuiTab-root.Mui-selected': { color: '#733567' }
    }
});

const CacheSettingList = () => {
    const dispatch = useDispatch();
    const { company } = useSelector((state) => state.company);
    const { cacheSetting } = useSelector((state) => state.adminSettings);
    const { componentNames, cacheList } = cacheSetting;
    const [anchorEl, setAnchorEl] = useState(null);
    const classes = useStyles();
    const [selectedSetting, setSelectedSetting] = useState(0);
    const [selectedKeys, setSelectedKeys] = useState({});
    const [selectAllStates, setSelectAllStates] = useState({});
    const [selectedKey, setSelectedKey] = useState({});

    const a11yProps = (index) => ({
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    });

    const handleSelectedSettingChange = (event, value) => {
        setSelectedSetting(value);
        setSelectedKeys({});
        setSelectAllStates({});
        setSelectedKey({});
    };

    const handleCache = (key, parentKey) => {
        const parentKeys = Object.keys(selectedKeys);
        const isHaveData = parentKeys.includes(parentKey) ? selectedKeys[parentKey]?.length : false;
        if (Object.keys(selectedKey).length || isHaveData) {
            let keys = {};
            if (isHaveData) keys = { keys: selectedKeys[parentKey] };
            else keys = { keys: selectedKey?.key };
            dispatch(clearCache({ companyId: company.id, data: keys })).then(
                () => {
                    setSelectedKeys({});
                    setSelectAllStates({});
                    setSelectedKey({});
                    dispatch(getCacheList({ companyId: company.id }));
                }
            );
        } else{
            toast.error('Please select at least one key to clear cache.');
        }
    };

    const handleCheckboxChange = (id, parentKey, data) => {
        setSelectedKeys((prevSelected) => {
            const prevTableSelection = prevSelected[parentKey] || [];
            const newSelection = prevTableSelection.includes(id)
                ? prevTableSelection.filter((key) => key !== id)
                : [...prevTableSelection, id];

            setSelectAllStates((prevSelectAllStates) => ({
                ...prevSelectAllStates,
                [parentKey]: newSelection.length === data.length
            }));
    
            return {
                ...prevSelected,
                [parentKey]: newSelection
            };
        });
    };
    

    const handleSelectAll = (data, parentKey) => {
        setSelectAllStates((prevSelectAllStates) => {
            const newSelectAll = !prevSelectAllStates[parentKey];
            setSelectedKeys((prevSelected) => ({
                ...prevSelected,
                [parentKey]: newSelectAll
                    ? data.filter((item) => item.size).map((item) => item.key)
                    : []
            }));
            return {
                ...prevSelectAllStates,
                [parentKey]: newSelectAll
            };
        });
    };

    const handlePopoverOpen = (event, key, reloadKey,downloadLink) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
        setSelectedKey({
            key: key,
            downloadLink: downloadLink,
            reloadKey: reloadKey
        });
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
        setSelectedKey({});
    };

    const open = Boolean(anchorEl);

    const handleReload = async () => {
        try {
            const response = await fetch(selectedKey?.reloadKey);
            if (response.status === 200) {
                toast.success('Reloaded successfully.');
            } else {
                toast.error(response.status);
            }
        } catch (error) {
            toast.error('An error occurred while fetching the URL');
        }
    };
    const handleDownload = async () => {
        if(selectedKey.downloadLink){
            const link = document.createElement('a');
            link.download = selectedKey.key;
            link.target = '_blank';
            link.href = selectedKey.downloadLink;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            toast.error('There is no download file available for this key.');
        }
            
    };
    const renderTable = (data, parentKey) => data
        .filter((item) => item.size)
        .map((item, index) => (
            <TableRow
                key={item?.key}
            >
                <TableCell className="table-row-data no-border table-row-checkbox">
                    <Checkbox
                        checked={
                            selectedKeys[parentKey]?.includes(item?.key) ||
                                false
                        }
                        onChange={() =>
                            handleCheckboxChange(item?.key, parentKey,data)
                        }
                    />
                </TableCell>
                <TableCell className="table-row-data no-border">
                    <Typography>
                        {item.key.replaceAll('$', ' ').split(' ')[0]}
                    </Typography>
                </TableCell>
                <TableCell className="table-row-data no-border">
                    <Typography>
                        {item.key.replaceAll('$', ' ').split(' ')[2]}
                    </Typography>
                </TableCell>
                <TableCell className="table-row-data no-border">
                    <Typography>
                        {item.key.replaceAll('$', ' ').split(' ')[3]}
                    </Typography>
                </TableCell>
                <TableCell className="table-row-data no-border cursor-pointer table-row-actions">
                    <img
                        height={20}
                        src={ActionsIcon}
                        width={20}
                        onClick={(event) =>
                            handlePopoverOpen(event, item?.key,item?.reload_cache_path,item?.download_link)
                        }
                    />
                    <Popover
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        disableScrollLock={true}
                        open={open}
                        sx={{
                            '& .MuiPaper-root': {
                                boxShadow:
                                        '0px 4px 6px -2px rgba(16, 24, 40, 0.05), inset 0px 8px 10px -7px rgba(16, 24, 40, 0.10)'
                            }
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        onClose={handlePopoverClose}
                    >
                        <Box>
                            <Box
                                className="action-button-box table-row-actions"
                                onClick={() => handleCache(item.key)}
                            >
                                <Trash color="#667085" />
                                <Typography className="action-button-text">
                                        Clear Cache
                                </Typography>
                            </Box>
                            <Box
                                className="table-row-actions"
                                data-testid="delete-option"
                                sx={{
                                    padding: '10px 16px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: '12px'
                                }}
                                onClick={() =>
                                    handleReload()
                                }
                            >
                                <Cached sx={{ color: '#667085' }} />
                                <Typography className="action-button-text">
                                        Reload
                                </Typography>
                            </Box>
                            <Box
                                className="table-row-actions"
                                data-testid="delete-option"
                                sx={{
                                    padding: '10px 16px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: '12px'
                                }}
                                onClick={() =>
                                    handleDownload()
                                }
                            >
                                <DownloadCloudIcon color="#667085" />
                                <Typography className="action-button-text">
                                        Download
                                </Typography>
                            </Box>
                        </Box>
                    </Popover>
                </TableCell>
            </TableRow>
        ));

    const cacheTableComponent = (data, parentKey) => (
        <>
            <Box className="ml-auto mr-1">
                <CustomButton
                    buttonColor="#AD509E"
                    handleClick={() => handleCache('', parentKey)}
                    icon={<Trash color="#FFFFFF" />}
                    title="Clear Cache"
                    titleColor="#FFFFFF"
                />
            </Box>
            <TableContainer
                className="no-box-shadow no-border"
                component={Paper}
            >
                <Table className="table-border-collapse no-border">
                    <TableHead className="queries-table-heading">
                        <TableRow>
                            <TableCell
                                className="queries-headers-title"
                                data-testid="data_source_table_selectAll"
                            >
                                <Checkbox
                                    checked={
                                        selectAllStates[parentKey] || false
                                    }
                                    onChange={() =>
                                        handleSelectAll(data, parentKey)
                                    }
                                />
                            </TableCell>
                            <TableCell className="queries-headers-title">
                                    Name
                            </TableCell>
                            <TableCell className="queries-headers-title">
                                    Start Date
                            </TableCell>
                            <TableCell className="queries-headers-title">
                                    End Date
                            </TableCell>
                            <TableCell className="queries-headers-title" />
                        </TableRow>
                    </TableHead>
                    <TableBody>{renderTable(data, parentKey)}</TableBody>
                </Table>
            </TableContainer>
        </>
    );

    const ComponentList = (value) => {
        const key = componentNames[value];
        const keyData = cacheList[key] ? Object.entries(cacheList[key]) : [];
        let isKey = false;

        const final = keyData.map((item, index) => {
            if (item[1].keys.length) {
                isKey = true;
                return (
                    <Box className="mt-2" key={index}>
                        <CustomAccordion
                            accordionContainerBackground="bg-primary-50"
                            accordionTitleColor="primary-color"
                            acoordianDetailsBackground="bg-gray-50"
                            byDefaultOpen={false}
                            component={cacheTableComponent(
                                item[1].keys,
                                item[0]
                            )}
                            padding="pt-10px"
                            title={capitalizeFirstLetter(item[1].name)}
                        />
                    </Box>
                );
            }
            return null;
        });

        if (!isKey) {
            return (
                <Grid item height={'100%'} xs={12}>
                    <Box className="text-center pt-5">
                        <Typography className="text-sm-medium gray-700">
                            No keys to clear cache.
                        </Typography>
                    </Box>
                </Grid>
            );
        }

        return final;
    };

    return (
        <Grid container className="flex-row" spacing={3}>
            <Grid item xs={12}>
                <Box className="flex-column gap-20">
                    {componentNames.length > 0 && (
                        <Box className="border-bottom-gray">
                            <Tabs
                                className={classes.tabs}
                                value={selectedSetting}
                                onChange={handleSelectedSettingChange}
                            >
                                {componentNames.map((setting, index) => (
                                    <Tab
                                        label={
                                            <Typography className="text-sm-medium">
                                                {setting === 'physician' ? 'Prescriber' : capitalizeFirstLetter(setting)}
                                            </Typography>
                                        }
                                        {...a11yProps(index)}
                                        key={index}
                                        sx={{ textTransform: 'none' }}
                                    />
                                ))}
                            </Tabs>
                        </Box>
                    )}
                </Box>
                {componentNames.length > 0 ? (
                    ComponentList(selectedSetting)
                ) : (
                    <Grid item className="mt-5" height={'100%'} xs={12}>
                        <Box className="text-center pt-5">
                            <Typography className="text-sm-medium gray-700">
                                No cache to clear.
                            </Typography>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};

export default CacheSettingList;
